import React, { useState } from "react";
import {
    Box,
    Container,
    Grid,
    Typography,
    Button,
} from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import PhoneIcon from "@mui/icons-material/Phone";
import tourOperatorImg from '../../assets/our-services-img/tour-operator.jpg';

const TourOperatorSection = () => {
    const [active, setActive] = useState(0);

    const menu = [
        "Honeymoon Packages",
        "Romantic Holiday Packages",
        "Group Holiday Packages",
        "Family Holiday Packages",
        "Wildlife Trips",
        "Heritage and Culture Trips",
        "Pilgrimage and Religious Tours",
        "Adventure Tours",
    ];

    return (
        <Box sx={{ background: "#eef3f7", py: 6 }}>
            <Container maxWidth="lg">
                <Grid container spacing={4}>

                    {/* LEFT SIDEBAR */}
                    <Grid size={{ xs: 12, md: 4 }}>
                        <Box
                            sx={{
                                position: "sticky",
                                top: "100px", // adjust based on header
                            }}
                        >
                            <Box
                                sx={{
                                    background: "#fff",
                                    borderRadius: "10px",
                                    p: 3,
                                    boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontWeight: 700,
                                        color: "#2b5c9e",
                                        mb: 2,
                                    }}
                                >
                                    Tour Operators
                                </Typography>

                                {menu.map((item, i) => (
                                    <Box
                                        key={i}
                                        onClick={() => setActive(i)}
                                        sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            py: 1.5,
                                            px: 1,
                                            borderRadius: "6px",
                                            mb: 0.5,
                                            cursor: "pointer",
                                            transition: "0.2s",
                                            background: active === i ? "#eef5ff" : "transparent",

                                            "&:hover": {
                                                background: "#f5f9ff",
                                            },
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                fontSize: "14px",
                                                color: active === i ? "#2b5c9e" : "#6b7a90",
                                                fontWeight: active === i ? 600 : 400,
                                            }}
                                        >
                                            {item}
                                        </Typography>

                                        <ChevronRightIcon
                                            sx={{
                                                fontSize: 18,
                                                color: active === i ? "#f5b400" : "#b0bccf",
                                                // color: "#f5b400",
                                            }}
                                        />
                                    </Box>
                                ))}

                                <Button
                                    variant="contained"
                                    startIcon={<PhoneIcon />}
                                    sx={{
                                        mt: 3,
                                        background: "#f5b400",
                                        color: "#fff",
                                        fontWeight: 700,
                                        textTransform: "none",
                                        px: 3,
                                        py: 1.2,
                                        borderRadius: "6px",
                                        "&:hover": {
                                            background: "#e0a200",
                                        },
                                    }}
                                >
                                    Contact Now
                                </Button>
                            </Box>
                        </Box>
                    </Grid>

                    {/* RIGHT CONTENT */}
                    <Grid size={{ xs: 12, md: 8 }}>

                        {/* IMAGE CARD */}
                        <Box
                            sx={{
                                background: "#fff",
                                borderRadius: "10px",
                                p: 2,
                                boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
                                mb: 3,
                            }}
                        >
                            <Box
                                component="img"
                                src={tourOperatorImg}
                                alt="travel"
                                sx={{
                                    width: "100%",
                                    borderRadius: "6px",
                                }}
                            />
                        </Box>

                        {/* TEXT CARD */}
                        <Box
                            sx={{
                                background: "#fff",
                                borderRadius: "10px",
                                p: 3,
                                boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
                            }}
                        >
                            <Typography
                                sx={{
                                    fontSize: "14px",
                                    color: "#6b7a90",
                                    lineHeight: 1.9,
                                    mb: 2,
                                }}
                            >
                                Are you looking forward to going on a spectacular Bangalore trip
                                with your family? Are you excited to witness numerous tourist
                                spots in the silicon valley of India? If yes, then Sudarshan
                                Holidays is the right choice for you. As one of the leading
                                travel agencies in Bangalore, Karnataka, no one can conduct more
                                efficient and wonderful tours than us.
                            </Typography>

                            <Typography
                                sx={{
                                    fontSize: "14px",
                                    color: "#6b7a90",
                                    lineHeight: 1.9,
                                }}
                            >
                                As a well-acknowledged travel agency, Sudarshan Holidays always
                                attempted to fulfil the different demands of travellers since
                                its inception in the year 2008. Being a famous tour operator, we
                                offer miscellaneous theme tour packages that can offer immense
                                pleasure and satisfaction to the clients. The tour packages we
                                offer are the following.
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default TourOperatorSection;